import { useAuth0 } from '@auth0/auth0-react'
import { SessionManagement_V1 } from '@rw1/auto-generated-clients'
import { useAppConfig, useEnvConfig } from 'rwo-react'
import { setAccessTokenProvider } from './accessTokenProvider'
import { joinUrl } from '.'

let sessionManagementClientV1:
  | SessionManagement_V1.SessionManagementClientV1
  | undefined

export const useSessionManagementServiceV1 =
  (): SessionManagement_V1.SessionManagementClientV1 => {
    const { getAccessTokenSilently } = useAuth0()
    const { backendAddress } = useEnvConfig()
    const { config } = useAppConfig()

    sessionManagementClientV1 ??=
      new SessionManagement_V1.SessionManagementClientV1(
        joinUrl(backendAddress, config['SessionManagementApiSuffix']),
      )
    setAccessTokenProvider(sessionManagementClientV1, getAccessTokenSilently)

    return sessionManagementClientV1
  }
